<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Business Profile</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (org && org.organisationDetails) {
  <div sxMaxWidth="500px" sxMargin="0 auto" sxPadding="medium" sxCol sxGap="10px">
    <div class="center full-width padding-heavy">
      <avatar-round [size]="120" [isEditMode]="canEdit" [imageUrl]="org?.displayPictureUrl" [autoBase]="true"
        [title]="org?.name" [onImageAction]="uploadOrgDisplayPic"></avatar-round>
    </div>
    <super-input label="Business Name" [(value)]="org.name" [readonly]="!canEdit"></super-input>

    <super-input placeholder="Eg. 1234567890" label="Phone Number" type="phone" [readonly]="!canEdit"
      [(value)]="org.organisationDetails.phoneNumber"></super-input>

    <ion-list>
      <ion-item (click)="editIndustry()" [button]="canEdit" detail="false">
        <ion-label>Industry</ion-label>
        <ion-text slot="end" color="dark" class="underline">{{
          org?.industry?.name
          }}</ion-text>
      </ion-item>
    </ion-list>





    <h3 class="text-xl font-medium m-0 ms-3 mt-6">Address</h3>
    <div class="w-full h-1 border-t border-ocean-300 mt-0"></div>

    <div class="flex flex-row items-center justify-between gap-2 mt-[-4px]">

      <super-input class="flex-1" [readonly]="!canEdit" [(value)]="org.organisationDetails.country" type="country"
        label="Country"></super-input>


      <div class="flex-1">
        <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.pinCode" (valueChange)="onPincodeChange()"
          label="Pincode" placeholder="Eg. 110001"></super-input>
        @if (validationErrors.pinCode) {
        <div sxPadding="5px 10px" sxFontSize="small" sxColor="danger">
          {{ validationErrors.pinCode }}
        </div>
        }
      </div>
    </div>

    <div class="flex flex-row items-center justify-between gap-2 ">
      <div class="flex-1">
        <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.city" label="City"
          placeholder=""></super-input>
        @if (validationErrors.city) {
        <div sxPadding="5px 10px" sxFontSize="small" sxColor="danger">
          {{ validationErrors.city }}
        </div>
        }
      </div>

      <div class="flex-1">
        <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.state" label="State"
          placeholder=""></super-input>
        @if (validationErrors.state) {
        <div sxPadding="5px 10px" sxFontSize="small" sxColor="danger">
          {{ validationErrors.state }}
        </div>
        }
      </div>
    </div>

    <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.addressLine" label="Street Address"
      type="textarea" placeholder="Eg. Floor 3, Building 01, Cyber City"></super-input>

    <div class="w-full h-1 border-t border-ocean-300 mt-4"></div>

    <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.pan" placeholder="Eg. ABCTY1234D"
      label="Business PAN"></super-input>
    <super-input [readonly]="!canEdit" [(value)]="org.organisationDetails.gst" placeholder="Eg. 22AAAAA0000A1Z5"
      label="GSTIN"></super-input>

    <super-button [permissionModule]="ApiModules.Organisation" [permissionOperation]="ApiOperations.update"
      [action]="updateOrg" width="full" [showError]="true" [disabled]="!hasUnsavedChanges" sxMargin="10px 0">Save Changes
    </super-button>

    <div class="w-full h-1 border-t border-ocean-300 mt-4"></div>

    <super-button [permissionModule]="ApiModules.Organisation" [permissionOperation]="ApiOperations.delete"
      sxMargin="20px 0" [action]="alertDelete" iconStart="trash-outline" textAlign="start" background="danger-fade"
      color="danger">Close Business Account
    </super-button>

  </div>
  }
</ion-content>